export default "__VITE_ASSET__e7bf6b00__"